import { createFileRoute } from '@tanstack/react-router'
import { CatalogPageViewModel } from '@/components/catalog/catalog-page/catalog-page.view-model'
import { buildPageMeta } from '@/lib/seo/build-page-meta'
import { catalogSearchSchema } from '@/schemas/catalog-search.schema'
import { productsQueryOptions } from '@/services/products/use-products'

export const Route = createFileRoute('/_editorial/catalogo/')({
  validateSearch: (search: Record<string, unknown>) => {
    const parsed = catalogSearchSchema.safeParse(search)
    return parsed.success ? parsed.data : { ocasiao: undefined }
  },
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(
      productsQueryOptions.byOptionalOccasion(deps.ocasiao),
    ),
  head: () =>
    buildPageMeta({
      title: 'Catálogo — Flora Ateliê',
      description:
        'Buquês, vasos, orquídeas e presentes florais da Flora Ateliê. Entrega em toda a cidade, com buquês montados à mão no ateliê.',
      path: '/catalogo',
    }),
  component: CatalogoRouteComponent,
})

function CatalogoRouteComponent() {
  const { ocasiao } = Route.useSearch()
  return <CatalogPageViewModel ocasiao={ocasiao} />
}
